(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.BC_CART_DRAWER_READY) return;
    window.BC_CART_DRAWER_READY = true;

    var activeDrawer = null;
    var lastFocused = null;

    function selectors(root, selector) {
      return Array.prototype.slice.call(root.querySelectorAll(selector));
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatMoney(cents, drawer, cart) {
      var amount = (Number(cents || 0) / 100);
      var currency = (cart && cart.currency) || (drawer && drawer.dataset.currency) || 'EUR';

      if (currency === 'EUR') {
        return '€' + amount.toFixed(2).replace('.', ',');
      }

      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency,
        }).format(amount);
      } catch (error) {
        return amount.toFixed(2);
      }
    }

    function icon(name) {
      var paths = {
        close: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
        truck: '<path d="M10 17h4V5H2v12h3"/><path d="M14 17h1"/><path d="M19 17h3v-6h-4l-4-4v10h1"/><circle cx="7.5" cy="17.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/>',
        lock: '<rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
        return: '<path d="M9 14 4 9l5-5"/><path d="M4 9h10a6 6 0 1 1 0 12h-2"/>',
        chat: '<path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"/>',
        paw: '<circle cx="11" cy="4" r="2"/><circle cx="18" cy="8" r="2"/><circle cx="20" cy="16" r="2"/><circle cx="4" cy="16" r="2"/><path d="M9 10c1.2-2 4.8-2 6 0l3 5.5c1.1 2-.3 4.5-2.6 4.5H8.6c-2.3 0-3.7-2.5-2.6-4.5z"/>',
        arrow: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
      };

      return '<svg aria-hidden="true" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + (paths[name] || paths.paw) + '</svg>';
    }

    function itemSubtitle(item) {
      if (!item || !item.options_with_values) return '';
      return item.options_with_values
        .map(function (option) { return option && option.value; })
        .filter(function (value) { return value && value !== 'Default Title'; })
        .join(' · ');
    }

    function imageUrl(item) {
      if (item && item.featured_image && item.featured_image.url) return item.featured_image.url;
      if (item && item.image) return item.image;
      return '';
    }

    function itemMarkup(item, drawer, cart) {
      var subtitle = itemSubtitle(item);
      var image = imageUrl(item);
      var title = escapeHtml(item.product_title || item.title || 'Cart item');
      var url = item.url || '#';

      return [
        '<article class="bc-cart-drawer__item" data-line-key="' + escapeHtml(item.key) + '">',
          '<a class="bc-cart-drawer__item-media" href="' + escapeHtml(url) + '">',
            image ? '<img src="' + escapeHtml(image) + '" alt="' + title + '" loading="lazy">' : '<span>' + icon('paw') + '</span>',
          '</a>',
          '<div class="bc-cart-drawer__item-main">',
            '<div class="bc-cart-drawer__item-copy">',
              '<a href="' + escapeHtml(url) + '">' + title + '</a>',
              subtitle ? '<p>' + escapeHtml(subtitle) + '</p>' : '',
            '</div>',
            '<div class="bc-cart-drawer__qty" aria-label="Quantity for ' + title + '">',
              '<button type="button" data-bc-cart-qty-minus aria-label="Decrease quantity">-</button>',
              '<span data-bc-cart-qty>' + Number(item.quantity || 0) + '</span>',
              '<button type="button" data-bc-cart-qty-plus aria-label="Increase quantity">+</button>',
            '</div>',
          '</div>',
          '<div class="bc-cart-drawer__item-side">',
            '<button class="bc-cart-drawer__remove" type="button" data-bc-cart-remove aria-label="Remove ' + title + '">' + icon('close') + '</button>',
            '<strong>' + formatMoney(item.final_line_price, drawer, cart) + '</strong>',
          '</div>',
        '</article>',
      ].join('');
    }

    function upsellMarkup(drawer, cart) {
      var template = drawer.querySelector('[data-bc-cart-upsell-template]') || document.querySelector('[data-bc-cart-upsell-template]');
      if (!template || !template.innerHTML) return '';
      var variantId = Number(drawer.dataset.upsellVariantId || 0);
      if (variantId && cart && cart.items && cart.items.some(function (item) { return Number(item.variant_id) === variantId; })) return '';
      var key = 'bc-cart-upsell-dismissed-' + (drawer.dataset.upsellVariantId || 'default');
      if (window.sessionStorage && sessionStorage.getItem(key) === '1') return '';
      return template.innerHTML;
    }

    function emptyMarkup(drawer) {
      return [
        '<div class="bc-cart-drawer__empty">',
          '<div class="bc-cart-drawer__empty-icon">' + icon('paw') + '</div>',
          '<h3>' + escapeHtml(drawer.dataset.emptyHeading || 'Your cart is empty') + '</h3>',
          '<p>' + escapeHtml(drawer.dataset.emptyMessage || 'Browse Bluey-approved pet essentials and add your favorites.') + '</p>',
          '<a class="bc-cart-drawer__empty-cta" href="' + escapeHtml(drawer.dataset.emptyLink || '/collections/all') + '">',
            escapeHtml(drawer.dataset.emptyCta || 'Browse the shop') + icon('arrow'),
          '</a>',
        '</div>',
      ].join('');
    }

    function filledMarkup(drawer, cart) {
      return [
        '<div class="bc-cart-drawer__items" data-bc-cart-items>',
          cart.items.map(function (item) { return itemMarkup(item, drawer, cart); }).join(''),
        '</div>',
        '<div class="bc-cart-drawer__shipping">',
          '<span>' + icon('truck') + escapeHtml(drawer.dataset.shippingMessage || 'Free delivery on this order') + '</span>',
          '<strong>' + escapeHtml(drawer.dataset.shippingPrice || '€0,00') + '</strong>',
        '</div>',
        upsellMarkup(drawer, cart),
      ].join('');
    }

    function setFooter(drawer, cart) {
      var footer = drawer.querySelector('[data-bc-cart-footer]');
      if (!footer) return;
      footer.hidden = !cart || !cart.item_count;
      if (!cart || !cart.item_count) return;

      var subtotal = footer.querySelector('[data-bc-cart-subtotal]');
      var total = footer.querySelector('[data-bc-cart-total]');
      if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price, drawer, cart);
      if (total) total.textContent = formatMoney(cart.total_price, drawer, cart);
    }

    function updateCountLabel(drawer, cart) {
      var label = drawer.querySelector('[data-bc-cart-count-label]');
      if (!label) return;
      var count = Number(cart && cart.item_count ? cart.item_count : 0);
      label.textContent = count === 1 ? '1 item' : count + ' items';
    }

    function renderCart(drawer, cart) {
      var body = drawer.querySelector('[data-bc-cart-body]');
      if (!body || !cart) return;
      updateCountLabel(drawer, cart);
      body.innerHTML = cart.item_count ? filledMarkup(drawer, cart) : emptyMarkup(drawer);
      setFooter(drawer, cart);
      drawer.dataset.cartItemCount = cart.item_count;
    }

    function setLoading(drawer, isLoading) {
      var loading = drawer.querySelector('[data-bc-cart-state="loading"]');
      if (loading) loading.hidden = !isLoading;
      drawer.classList.toggle('is-busy', !!isLoading);
    }

    function thirdPartyWidgets() {
      return selectors(document, '#ShopifyChat, inbox-online-store-chat#ShopifyChat, .bacurr-cur-block, .bacurr-dropdownChoices');
    }

    function setThirdPartyWidgetsHidden(hidden) {
      thirdPartyWidgets().forEach(function (widget) {
        if (hidden) {
          if (!widget.dataset.bcCartWidgetHidden) {
            widget.dataset.bcCartWidgetHidden = 'true';
            widget.dataset.bcCartPreviousOpacity = widget.style.opacity || '';
            widget.dataset.bcCartPreviousVisibility = widget.style.visibility || '';
            widget.dataset.bcCartPreviousPointerEvents = widget.style.pointerEvents || '';
          }
          widget.style.setProperty('opacity', '0', 'important');
          widget.style.setProperty('visibility', 'hidden', 'important');
          widget.style.setProperty('pointer-events', 'none', 'important');
          return;
        }

        if (!widget.dataset.bcCartWidgetHidden) return;
        if (widget.dataset.bcCartPreviousOpacity) {
          widget.style.opacity = widget.dataset.bcCartPreviousOpacity;
        } else {
          widget.style.removeProperty('opacity');
        }
        if (widget.dataset.bcCartPreviousVisibility) {
          widget.style.visibility = widget.dataset.bcCartPreviousVisibility;
        } else {
          widget.style.removeProperty('visibility');
        }
        if (widget.dataset.bcCartPreviousPointerEvents) {
          widget.style.pointerEvents = widget.dataset.bcCartPreviousPointerEvents;
        } else {
          widget.style.removeProperty('pointer-events');
        }
        delete widget.dataset.bcCartWidgetHidden;
        delete widget.dataset.bcCartPreviousOpacity;
        delete widget.dataset.bcCartPreviousVisibility;
        delete widget.dataset.bcCartPreviousPointerEvents;
      });
    }

    function setError(drawer, hasError) {
      var error = drawer.querySelector('[data-bc-cart-state="error"]');
      if (error) error.hidden = !hasError;
    }

    function fetchCart(drawer) {
      setError(drawer, false);
      setLoading(drawer, true);
      return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart refresh failed');
          return response.json();
        })
        .then(function (cart) {
          renderCart(drawer, cart);
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'bc-cart-drawer', data: { itemCount: cart.item_count, source: 'bc-cart-drawer' } },
          }));
          return cart;
        })
        .catch(function () {
          setError(drawer, true);
        })
        .finally(function () {
          setLoading(drawer, false);
        });
    }

    function changeQuantity(drawer, key, quantity) {
      setLoading(drawer, true);
      setError(drawer, false);
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then(function (cart) {
          renderCart(drawer, cart);
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'bc-cart-drawer', data: { itemCount: cart.item_count, source: 'bc-cart-drawer' } },
          }));
        })
        .catch(function () {
          setError(drawer, true);
        })
        .finally(function () {
          setLoading(drawer, false);
        });
    }

    function addUpsell(drawer, variantId) {
      if (!variantId) return;
      setLoading(drawer, true);
      setError(drawer, false);
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Upsell add failed');
          return fetchCart(drawer);
        })
        .catch(function () {
          setError(drawer, true);
        })
        .finally(function () {
          setLoading(drawer, false);
        });
    }

    function openDrawer(drawer, cart) {
      if (!drawer) return;
      activeDrawer = drawer;
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      document.body.classList.add('bc-cart-drawer-open');
      setThirdPartyWidgetsHidden(true);
      drawer.querySelector('.bc-cart-drawer__panel').focus({ preventScroll: true });
      if (cart) {
        renderCart(drawer, cart);
      } else {
        fetchCart(drawer);
      }
    }

    function closeDrawer(drawer) {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('bc-cart-drawer-open');
      setThirdPartyWidgetsHidden(false);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus({ preventScroll: true });
      }
      activeDrawer = null;
    }

    function getDrawer() {
      return document.querySelector('[data-bc-cart-drawer]');
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-bc-cart-open]');
      if (opener) {
        var drawer = getDrawer();
        if (drawer) {
          event.preventDefault();
          openDrawer(drawer);
        }
        return;
      }

      var close = event.target.closest('[data-bc-cart-close]');
      if (close) {
        closeDrawer(close.closest('[data-bc-cart-drawer]'));
        return;
      }

      var retry = event.target.closest('[data-bc-cart-retry]');
      if (retry) {
        fetchCart(retry.closest('[data-bc-cart-drawer]'));
        return;
      }

      var qtyButton = event.target.closest('[data-bc-cart-qty-minus], [data-bc-cart-qty-plus], [data-bc-cart-remove]');
      if (qtyButton) {
        var drawer = qtyButton.closest('[data-bc-cart-drawer]');
        var item = qtyButton.closest('[data-line-key]');
        if (!drawer || !item) return;
        var current = Number((item.querySelector('[data-bc-cart-qty]') || {}).textContent || 0);
        var next = current;
        if (qtyButton.matches('[data-bc-cart-remove]')) next = 0;
        if (qtyButton.matches('[data-bc-cart-qty-minus]')) next = current - 1;
        if (qtyButton.matches('[data-bc-cart-qty-plus]')) next = current + 1;
        changeQuantity(drawer, item.dataset.lineKey, next);
        return;
      }

      var upsellAdd = event.target.closest('[data-bc-cart-upsell-add]');
      if (upsellAdd) {
        addUpsell(upsellAdd.closest('[data-bc-cart-drawer]'), upsellAdd.dataset.variantId);
        return;
      }

      var upsellDismiss = event.target.closest('[data-bc-cart-upsell-dismiss]');
      if (upsellDismiss) {
        var upsell = upsellDismiss.closest('[data-bc-cart-upsell]');
        var drawer = upsellDismiss.closest('[data-bc-cart-drawer]');
        var key = 'bc-cart-upsell-dismissed-' + ((drawer && drawer.dataset.upsellVariantId) || 'default');
        if (window.sessionStorage) sessionStorage.setItem(key, '1');
        if (upsell) upsell.hidden = true;
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && activeDrawer) {
        closeDrawer(activeDrawer);
      }
    });

    document.addEventListener('bc-cart:open', function (event) {
      openDrawer(getDrawer(), event.detail && event.detail.cart);
    });

    document.addEventListener('bc-cart:refresh', function (event) {
      var drawer = getDrawer();
      if (!drawer) return;
      if (event.detail && event.detail.cart) {
        renderCart(drawer, event.detail.cart);
      } else {
        fetchCart(drawer);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-bc-collection-sort]')) return;
    if (event.target.form) event.target.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-faq"] && !Shopify.designMode) return;
  try {
    
  if (!window.BCFAQAccordion) {
    window.BCFAQAccordion = true;

    document.addEventListener('click', function(event) {
      var button = event.target.closest('.bc-faq__button');
      if (!button) return;

      var item = button.closest('.bc-faq__item');
      var panelId = button.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      if (!item || !panel) return;

      var willOpen = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      item.classList.toggle('is-open', willOpen);

      if (willOpen) {
        panel.hidden = false;
      } else {
        panel.hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-product-bowl"] && !Shopify.designMode) return;
  try {
    
  if (!window.BCBowlProductInit) {
    window.BCBowlProductInit = true;

    function bowlMoney(cents, currency) {
      var value = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: currency || 'EUR' }).format(value);
      } catch (e) {
        return 'EUR ' + value.toFixed(2);
      }
    }

    function bowlSetGallery(section, index) {
      var panels = section.querySelectorAll('[data-bc-bowl-panel]');
      var thumbs = section.querySelectorAll('[data-bc-bowl-thumb]');
      if (!panels.length) return;
      var next = (index + panels.length) % panels.length;
      panels.forEach(function(panel, i) {
        panel.toggleAttribute('hidden', i !== next);
        panel.classList.toggle('is-active', i === next);
      });
      thumbs.forEach(function(thumb, i) {
        thumb.classList.toggle('is-active', i === next);
      });
    }

    function bowlFormatChoice(value) {
      if (value === 'set') return 'Set of 2';
      return value ? value.charAt(0).toUpperCase() + value.slice(1) : '';
    }

    function bowlMatchesVariant(button, filters) {
      var keys = Object.keys(filters || {});
      for (var i = 0; i < keys.length; i += 1) {
        if (button.getAttribute('data-' + keys[i]) !== filters[keys[i]]) return false;
      }
      return true;
    }

    function bowlFindVariant(section, filters, availableOnly) {
      var variants = section.querySelectorAll('[data-bc-bowl-variant]');
      var fallback = null;
      for (var i = 0; i < variants.length; i += 1) {
        if (!bowlMatchesVariant(variants[i], filters)) continue;
        if (!availableOnly || variants[i].getAttribute('data-variant-available') === 'true') return variants[i];
        if (!fallback) fallback = variants[i];
      }
      return availableOnly ? null : fallback;
    }

    function bowlGetState(section) {
      var selected = section.querySelector('[data-bc-bowl-variant].is-selected') || section.querySelector('[data-bc-bowl-variant]');
      return {
        pack: section.getAttribute('data-selected-pack') || (selected && selected.getAttribute('data-pack')) || 'single',
        color: section.getAttribute('data-selected-color') || (selected && selected.getAttribute('data-color')) || 'green'
      };
    }

    function bowlChoiceIsAvailable(section, state, type, value) {
      if (type === 'pack') {
        return !!bowlFindVariant(section, { pack: value }, true);
      }
      return !!bowlFindVariant(section, { pack: state.pack, color: value }, true);
    }

    function bowlSyncControls(section, button) {
      var state = {
        pack: button.getAttribute('data-pack') || 'single',
        color: button.getAttribute('data-color') || 'green'
      };
      var price = bowlMoney(Number(button.getAttribute('data-variant-price-cents') || 0), section.getAttribute('data-currency'));
      var summary = (state.pack === 'set' ? 'Set of 2' : 'Single bowl') + ' - ' + bowlFormatChoice(state.color);

      section.setAttribute('data-selected-pack', state.pack);
      section.setAttribute('data-selected-color', state.color);

      section.querySelectorAll('[data-bc-bowl-choice]').forEach(function(choice) {
        var type = choice.getAttribute('data-bc-bowl-choice');
        var value = choice.getAttribute('data-choice-value');
        var selected = state[type] === value;
        var available = bowlChoiceIsAvailable(section, state, type, value);

        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
        choice.disabled = !available;
      });

      section.querySelectorAll('[data-bc-bowl-summary]').forEach(function(node) {
        node.textContent = summary;
      });
      section.querySelectorAll('[data-bc-bowl-summary-price]').forEach(function(node) {
        node.textContent = price;
      });
    }

    function bowlSelectChoice(section, type, value) {
      var state = bowlGetState(section);
      var next = null;
      state[type] = value;

      next = bowlFindVariant(section, state, true);
      if (!next && type === 'pack') {
        next = bowlFindVariant(section, { pack: state.pack }, true);
      }
      if (!next && type === 'color') {
        next = bowlFindVariant(section, { color: state.color }, true);
      }
      if (!next) {
        next = bowlFindVariant(section, {}, true) || section.querySelector('[data-bc-bowl-variant]');
      }
      if (next) bowlUpdateVariant(section, next);
    }

    function bowlUpdateVariant(section, button) {
      if (!button) return;
      var id = button.getAttribute('data-variant-id');
      var title = button.getAttribute('data-variant-title') || '';
      var cents = Number(button.getAttribute('data-variant-price-cents') || 0);
      var available = button.getAttribute('data-variant-available') === 'true';
      var qtyInput = section.querySelector('[data-bc-bowl-quantity]');
      var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10));

      section.querySelectorAll('[data-bc-bowl-variant]').forEach(function(other) {
        other.classList.toggle('is-selected', other === button);
      });
      section.querySelectorAll('[data-bc-bowl-variant-input]').forEach(function(input) {
        input.value = id;
      });
      section.querySelectorAll('[data-bc-bowl-price]').forEach(function(node) {
        node.textContent = bowlMoney(cents, section.getAttribute('data-currency'));
      });
      section.querySelectorAll('[data-bc-bowl-title], [data-bc-bowl-sticky-title]').forEach(function(node) {
        node.textContent = title;
      });
      section.querySelectorAll('[data-bc-bowl-sticky-price], [data-bc-bowl-cta-price]').forEach(function(node) {
        node.textContent = bowlMoney(cents * quantity, section.getAttribute('data-currency'));
      });
      section.querySelectorAll('[data-bc-bowl-submit]').forEach(function(submit) {
        submit.disabled = !available;
      });
      bowlSyncControls(section, button);
    }

    function bowlUpdateQuantity(section, value) {
      var qty = Math.max(1, parseInt(value || '1', 10));
      section.querySelectorAll('[data-bc-bowl-quantity]').forEach(function(input) {
        input.value = qty;
      });
      section.querySelectorAll('[data-bc-bowl-qty-input]').forEach(function(input) {
        input.value = qty;
      });
      var selected = section.querySelector('[data-bc-bowl-variant].is-selected') || section.querySelector('[data-bc-bowl-variant]');
      if (selected) bowlUpdateVariant(section, selected);
    }

    function bowlInit(section) {
      section.querySelectorAll('[data-bc-bowl-thumb]').forEach(function(button) {
        button.addEventListener('click', function() {
          bowlSetGallery(section, Number(button.getAttribute('data-bc-bowl-thumb') || 0));
        });
      });

      section.querySelectorAll('[data-bc-bowl-choice]').forEach(function(button) {
        button.addEventListener('click', function() {
          if (button.disabled) return;
          bowlSelectChoice(section, button.getAttribute('data-bc-bowl-choice'), button.getAttribute('data-choice-value'));
        });
      });

      section.querySelectorAll('[data-bc-bowl-qty-minus]').forEach(function(button) {
        button.addEventListener('click', function() {
          var input = section.querySelector('[data-bc-bowl-quantity]');
          bowlUpdateQuantity(section, Number(input && input.value ? input.value : 1) - 1);
        });
      });

      section.querySelectorAll('[data-bc-bowl-qty-plus]').forEach(function(button) {
        button.addEventListener('click', function() {
          var input = section.querySelector('[data-bc-bowl-quantity]');
          bowlUpdateQuantity(section, Number(input && input.value ? input.value : 1) + 1);
        });
      });

      section.querySelectorAll('[data-bc-bowl-quantity]').forEach(function(input) {
        input.addEventListener('change', function() {
          bowlUpdateQuantity(section, input.value);
        });
      });

      section.querySelectorAll('.bc-product-bowl__faq button').forEach(function(button) {
        button.addEventListener('click', function() {
          var item = button.closest('.bc-product-bowl__faq-item');
          var panel = document.getElementById(button.getAttribute('aria-controls'));
          var willOpen = button.getAttribute('aria-expanded') !== 'true';
          if (!item || !panel) return;
          button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          item.classList.toggle('is-open', willOpen);
          panel.toggleAttribute('hidden', !willOpen);
        });
      });

      var selected = section.querySelector('[data-bc-bowl-variant].is-selected') || section.querySelector('[data-bc-bowl-variant]');
      if (selected) bowlUpdateVariant(section, selected);
    }

    function bowlInitAll() {
      document.querySelectorAll('[data-bc-bowl-section]').forEach(bowlInit);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bowlInitAll);
    } else {
      bowlInitAll();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-product-harness"] && !Shopify.designMode) return;
  try {
    
  if (!window.BCHarnessProductInit) {
    window.BCHarnessProductInit = true;

    function harnessMoney(cents, currency) {
      var value = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: currency || 'EUR' }).format(value);
      } catch (e) {
        return 'EUR ' + value.toFixed(2);
      }
    }

    function harnessSetGallery(section, index) {
      var panels = section.querySelectorAll('[data-bc-harness-panel]');
      var thumbs = section.querySelectorAll('[data-bc-harness-thumb]');
      if (!panels.length) return;
      var next = (index + panels.length) % panels.length;
      panels.forEach(function(panel, i) {
        panel.toggleAttribute('hidden', i !== next);
        panel.classList.toggle('is-active', i === next);
      });
      thumbs.forEach(function(thumb, i) {
        thumb.classList.toggle('is-active', i === next);
      });
    }

    function harnessFormatChoice(value) {
      if (value === '2-pack') return '2-pack';
      if (value === 'xs') return 'XS';
      if (value === 's') return 'S';
      return value ? value.charAt(0).toUpperCase() + value.slice(1) : '';
    }

    function harnessMatchesVariant(button, filters) {
      var keys = Object.keys(filters || {});
      for (var i = 0; i < keys.length; i += 1) {
        if (button.getAttribute('data-' + keys[i]) !== filters[keys[i]]) return false;
      }
      return true;
    }

    function harnessFindVariant(section, filters, availableOnly) {
      var variants = section.querySelectorAll('[data-bc-harness-variant]');
      var fallback = null;
      for (var i = 0; i < variants.length; i += 1) {
        if (!harnessMatchesVariant(variants[i], filters)) continue;
        if (!availableOnly || variants[i].getAttribute('data-variant-available') === 'true') return variants[i];
        if (!fallback) fallback = variants[i];
      }
      return availableOnly ? null : fallback;
    }

    function harnessGetState(section) {
      var selected = section.querySelector('[data-bc-harness-variant].is-selected') || section.querySelector('[data-bc-harness-variant]');
      return {
        pack: section.getAttribute('data-selected-pack') || (selected && selected.getAttribute('data-pack')) || 'single',
        size: section.getAttribute('data-selected-size') || (selected && selected.getAttribute('data-size')) || 's',
        color: section.getAttribute('data-selected-color') || (selected && selected.getAttribute('data-color')) || 'black'
      };
    }

    function harnessChoiceIsAvailable(section, state, type, value) {
      var test = {
        pack: state.pack,
        size: state.size,
        color: state.color
      };
      test[type] = value;

      if (type === 'pack') {
        return !!harnessFindVariant(section, { pack: value, size: state.size }, true);
      }

      return !!harnessFindVariant(section, test, true);
    }

    function harnessSyncControls(section, button) {
      var state = {
        pack: button.getAttribute('data-pack') || 'single',
        size: button.getAttribute('data-size') || 's',
        color: button.getAttribute('data-color') || 'black'
      };
      var price = harnessMoney(Number(button.getAttribute('data-variant-price-cents') || 0), section.getAttribute('data-currency'));
      var summary = (state.pack === '2-pack' ? '2-pack' : 'Single harness') + ' · ' + harnessFormatChoice(state.color) + ' · ' + harnessFormatChoice(state.size);

      section.setAttribute('data-selected-pack', state.pack);
      section.setAttribute('data-selected-size', state.size);
      section.setAttribute('data-selected-color', state.color);

      section.querySelectorAll('[data-bc-harness-choice]').forEach(function(choice) {
        var type = choice.getAttribute('data-bc-harness-choice');
        var value = choice.getAttribute('data-choice-value');
        var selected = state[type] === value;
        var available = harnessChoiceIsAvailable(section, state, type, value);

        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
        choice.disabled = !available;
      });

      section.querySelectorAll('[data-bc-harness-summary]').forEach(function(node) {
        node.textContent = summary;
      });
      section.querySelectorAll('[data-bc-harness-summary-price]').forEach(function(node) {
        node.textContent = price;
      });
    }

    function harnessSelectChoice(section, type, value) {
      var state = harnessGetState(section);
      var next = null;
      state[type] = value;

      next = harnessFindVariant(section, state, true);
      if (!next && type === 'pack') {
        next = harnessFindVariant(section, { pack: state.pack, size: state.size }, true) || harnessFindVariant(section, { pack: state.pack }, true);
      }
      if (!next && type === 'size') {
        next = harnessFindVariant(section, { pack: state.pack, size: state.size }, true) || harnessFindVariant(section, { size: state.size }, true);
      }
      if (!next && type === 'color') {
        next = harnessFindVariant(section, { pack: state.pack, color: state.color }, true) || harnessFindVariant(section, { color: state.color }, true);
      }
      if (!next) {
        next = harnessFindVariant(section, {}, true) || section.querySelector('[data-bc-harness-variant]');
      }
      if (next) harnessUpdateVariant(section, next);
    }

    function harnessUpdateVariant(section, button) {
      if (!button) return;
      var id = button.getAttribute('data-variant-id');
      var title = button.getAttribute('data-variant-title') || '';
      var cents = Number(button.getAttribute('data-variant-price-cents') || 0);
      var available = button.getAttribute('data-variant-available') === 'true';
      var qtyInput = section.querySelector('[data-bc-harness-quantity]');
      var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10));

      section.querySelectorAll('[data-bc-harness-variant]').forEach(function(other) {
        other.classList.toggle('is-selected', other === button);
      });
      section.querySelectorAll('[data-bc-harness-variant-input]').forEach(function(input) {
        input.value = id;
      });
      section.querySelectorAll('[data-bc-harness-price]').forEach(function(node) {
        node.textContent = harnessMoney(cents, section.getAttribute('data-currency'));
      });
      section.querySelectorAll('[data-bc-harness-title], [data-bc-harness-sticky-title]').forEach(function(node) {
        node.textContent = title;
      });
      section.querySelectorAll('[data-bc-harness-sticky-price], [data-bc-harness-cta-price]').forEach(function(node) {
        node.textContent = harnessMoney(cents * quantity, section.getAttribute('data-currency'));
      });
      section.querySelectorAll('[data-bc-harness-submit]').forEach(function(submit) {
        submit.disabled = !available;
      });
      harnessSyncControls(section, button);
    }

    function harnessUpdateQuantity(section, value) {
      var qty = Math.max(1, parseInt(value || '1', 10));
      section.querySelectorAll('[data-bc-harness-quantity]').forEach(function(input) {
        input.value = qty;
      });
      section.querySelectorAll('[data-bc-harness-qty-input]').forEach(function(input) {
        input.value = qty;
      });
      var selected = section.querySelector('[data-bc-harness-variant].is-selected') || section.querySelector('[data-bc-harness-variant]');
      if (selected) harnessUpdateVariant(section, selected);
    }

    function harnessInit(section) {
      section.querySelectorAll('[data-bc-harness-thumb]').forEach(function(button) {
        button.addEventListener('click', function() {
          harnessSetGallery(section, Number(button.getAttribute('data-bc-harness-thumb') || 0));
        });
      });

      section.querySelectorAll('[data-bc-harness-variant]').forEach(function(button) {
        button.addEventListener('click', function() {
          harnessUpdateVariant(section, button);
        });
      });

      section.querySelectorAll('[data-bc-harness-choice]').forEach(function(button) {
        button.addEventListener('click', function() {
          if (button.disabled) return;
          harnessSelectChoice(section, button.getAttribute('data-bc-harness-choice'), button.getAttribute('data-choice-value'));
        });
      });

      section.querySelectorAll('[data-bc-harness-qty-minus]').forEach(function(button) {
        button.addEventListener('click', function() {
          var input = section.querySelector('[data-bc-harness-quantity]');
          harnessUpdateQuantity(section, Number(input && input.value ? input.value : 1) - 1);
        });
      });

      section.querySelectorAll('[data-bc-harness-qty-plus]').forEach(function(button) {
        button.addEventListener('click', function() {
          var input = section.querySelector('[data-bc-harness-quantity]');
          harnessUpdateQuantity(section, Number(input && input.value ? input.value : 1) + 1);
        });
      });

      section.querySelectorAll('[data-bc-harness-quantity]').forEach(function(input) {
        input.addEventListener('change', function() {
          harnessUpdateQuantity(section, input.value);
        });
      });

      section.querySelectorAll('.bc-product-harness__faq button').forEach(function(button) {
        button.addEventListener('click', function() {
          var item = button.closest('.bc-product-harness__faq-item');
          var panel = document.getElementById(button.getAttribute('aria-controls'));
          var willOpen = button.getAttribute('aria-expanded') !== 'true';
          if (!item || !panel) return;
          button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          item.classList.toggle('is-open', willOpen);
          panel.toggleAttribute('hidden', !willOpen);
        });
      });

      var selected = section.querySelector('[data-bc-harness-variant].is-selected') || section.querySelector('[data-bc-harness-variant]');
      if (selected) harnessUpdateVariant(section, selected);
    }

    function harnessInitAll() {
      document.querySelectorAll('[data-bc-harness-section]').forEach(harnessInit);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', harnessInitAll);
    } else {
      harnessInitAll();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-product-spring-toys"] && !Shopify.designMode) return;
  try {
    
  function bcSpringInit(section) {
    if (!section || section.dataset.bcSpringReady === 'true') return;
    section.dataset.bcSpringReady = 'true';

    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-bc-spring-panel]'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-bc-spring-thumb]'));
    var activeIndex = 0;

    function showImage(index) {
      if (!panels.length) return;
      activeIndex = (index + panels.length) % panels.length;
      panels.forEach(function (panel, panelIndex) {
        var isActive = panelIndex === activeIndex;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });
      thumbs.forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle('is-active', thumbIndex === activeIndex);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showImage(Number(thumb.getAttribute('data-bc-spring-thumb') || 0));
      });
    });

    var prev = section.querySelector('[data-bc-spring-prev]');
    var next = section.querySelector('[data-bc-spring-next]');
    if (prev) prev.addEventListener('click', function () { showImage(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { showImage(activeIndex + 1); });

    var quantity = section.querySelector('[data-bc-spring-quantity]');
    var qtyInputs = Array.prototype.slice.call(section.querySelectorAll('[data-bc-spring-qty-input]'));

    function normalizeQuantity(value) {
      var nextValue = parseInt(value, 10);
      if (!nextValue || nextValue < 1) nextValue = 1;
      return nextValue;
    }

    function setQuantity(value) {
      var nextValue = normalizeQuantity(value);
      if (quantity) quantity.value = String(nextValue);
      qtyInputs.forEach(function (input) {
        input.value = String(nextValue);
      });
    }

    if (quantity) {
      quantity.addEventListener('input', function () {
        setQuantity(quantity.value);
      });
    }

    var minus = section.querySelector('[data-bc-spring-qty-minus]');
    var plus = section.querySelector('[data-bc-spring-qty-plus]');
    if (minus) minus.addEventListener('click', function () { setQuantity(normalizeQuantity(quantity && quantity.value) - 1); });
    if (plus) plus.addEventListener('click', function () { setQuantity(normalizeQuantity(quantity && quantity.value) + 1); });

    section.querySelectorAll('.bc-product-spring__faq button').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.bc-product-spring__faq-item');
        var panel = item && item.querySelector('.bc-product-spring__faq-panel');
        var isOpen = item && item.classList.contains('is-open');
        if (!item || !panel) return;

        item.classList.toggle('is-open', !isOpen);
        panel.hidden = isOpen;
        button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  }

  function bcSpringInitAll() {
    document.querySelectorAll('[data-bc-spring-section]').forEach(bcSpringInit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bcSpringInitAll);
  } else {
    bcSpringInitAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bcSpringInit(event.target && event.target.querySelector('[data-bc-spring-section]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-product-waterflow"] && !Shopify.designMode) return;
  try {
    
  if (!window.BCWaterflowProductInit) {
    window.BCWaterflowProductInit = true;

    function formatMoney(cents, currency) {
      var value = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: currency || 'EUR' }).format(value);
      } catch (e) {
        return '€' + value.toFixed(2).replace('.', ',');
      }
    }

    function setGallery(section, index) {
      var panels = section.querySelectorAll('[data-bc-gallery-panel]');
      var thumbs = section.querySelectorAll('[data-bc-gallery-thumb]');
      if (!panels.length) return;
      var next = (index + panels.length) % panels.length;
      panels.forEach(function(panel, i) {
        panel.toggleAttribute('hidden', i !== next);
        panel.classList.toggle('is-active', i === next);
      });
      thumbs.forEach(function(thumb, i) {
        thumb.classList.toggle('is-active', i === next);
      });
      section.setAttribute('data-active-gallery', String(next));
    }

    function updateVariant(section, button) {
      var id = button.getAttribute('data-variant-id');
      var title = button.getAttribute('data-variant-title') || '';
      var cents = Number(button.getAttribute('data-variant-price-cents') || 0);
      var compareCents = Number(button.getAttribute('data-variant-compare-cents') || 0);
      var hasCompare = compareCents > cents;
      var continueSelling = button.getAttribute('data-variant-inventory-policy') === 'continue';
      var available = button.getAttribute('data-variant-available') === 'true' || continueSelling;
      var qtyInput = section.querySelector('[data-bc-quantity]');
      var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10));

      section.querySelectorAll('[data-bc-variant-button]').forEach(function(other) {
        other.classList.toggle('is-selected', other === button);
      });
      section.querySelectorAll('[data-bc-variant-input]').forEach(function(input) {
        input.value = id;
      });
      section.querySelectorAll('[data-bc-selected-price]').forEach(function(node) {
        node.textContent = formatMoney(cents, section.getAttribute('data-currency'));
      });
      section.querySelectorAll('[data-bc-selected-compare]').forEach(function(node) {
        node.textContent = formatMoney(compareCents, section.getAttribute('data-currency'));
        node.toggleAttribute('hidden', !hasCompare);
      });
      section.querySelectorAll('[data-bc-sale-badge]').forEach(function(node) {
        node.toggleAttribute('hidden', !hasCompare);
      });
      section.querySelectorAll('[data-bc-selected-title]').forEach(function(node) {
        node.textContent = title;
      });
      section.querySelectorAll('[data-bc-sticky-title]').forEach(function(node) {
        node.textContent = title;
      });
      section.querySelectorAll('[data-bc-sticky-price]').forEach(function(node) {
        node.textContent = formatMoney(cents * quantity, section.getAttribute('data-currency'));
      });
      section.querySelectorAll('[data-bc-cta-price]').forEach(function(node) {
        node.textContent = formatMoney(cents * quantity, section.getAttribute('data-currency'));
      });
      section.querySelectorAll('[data-bc-submit]').forEach(function(submit) {
        submit.disabled = !available;
      });
      section.setAttribute('data-selected-cents', String(cents));
    }

    function padNumber(value) {
      return String(value).padStart(2, '0');
    }

    function updateCountdown(timer) {
      var deadline = Date.parse(timer.getAttribute('data-bc-countdown-deadline') || '');
      if (Number.isNaN(deadline)) return false;

      var diff = deadline - Date.now();
      if (diff <= 0) {
        timer.setAttribute('hidden', '');
        return false;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      var daysNode = timer.querySelector('[data-bc-countdown-days]');
      var hoursNode = timer.querySelector('[data-bc-countdown-hours]');
      var minutesNode = timer.querySelector('[data-bc-countdown-minutes]');
      var secondsNode = timer.querySelector('[data-bc-countdown-seconds]');

      if (daysNode) daysNode.textContent = padNumber(days);
      if (hoursNode) hoursNode.textContent = padNumber(hours);
      if (minutesNode) minutesNode.textContent = padNumber(minutes);
      if (secondsNode) secondsNode.textContent = padNumber(seconds);

      return true;
    }

    function initCountdown(timer) {
      if (timer.getAttribute('data-bc-countdown-started') === 'true') return;
      timer.setAttribute('data-bc-countdown-started', 'true');
      var intervalId;
      var tick = function() {
        var active = updateCountdown(timer);
        if (!active && intervalId) {
          clearInterval(intervalId);
        }
      };
      tick();
      intervalId = setInterval(tick, 1000);
    }

    function updateQuantity(section, value) {
      var qty = Math.max(1, parseInt(value || '1', 10));
      section.querySelectorAll('[data-bc-quantity]').forEach(function(input) {
        input.value = qty;
      });
      section.querySelectorAll('[data-bc-qty-input]').forEach(function(input) {
        input.value = qty;
      });
      var selected = section.querySelector('[data-bc-variant-button].is-selected');
      if (selected) updateVariant(section, selected);
    }

    function initSection(section) {
      setGallery(section, 0);

      section.querySelectorAll('[data-bc-gallery-thumb]').forEach(function(button) {
        button.addEventListener('click', function() {
          setGallery(section, Number(button.getAttribute('data-bc-gallery-thumb') || 0));
        });
      });

      var prev = section.querySelector('[data-bc-gallery-prev]');
      var next = section.querySelector('[data-bc-gallery-next]');
      if (prev) {
        prev.addEventListener('click', function() {
          setGallery(section, Number(section.getAttribute('data-active-gallery') || 0) - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function() {
          setGallery(section, Number(section.getAttribute('data-active-gallery') || 0) + 1);
        });
      }

      section.querySelectorAll('[data-bc-variant-button]').forEach(function(button) {
        button.addEventListener('click', function() {
          updateVariant(section, button);
        });
      });

      section.querySelectorAll('[data-bc-qty-minus]').forEach(function(button) {
        button.addEventListener('click', function() {
          var input = section.querySelector('[data-bc-quantity]');
          updateQuantity(section, Number(input && input.value ? input.value : 1) - 1);
        });
      });

      section.querySelectorAll('[data-bc-qty-plus]').forEach(function(button) {
        button.addEventListener('click', function() {
          var input = section.querySelector('[data-bc-quantity]');
          updateQuantity(section, Number(input && input.value ? input.value : 1) + 1);
        });
      });

      section.querySelectorAll('[data-bc-quantity]').forEach(function(input) {
        input.addEventListener('change', function() {
          updateQuantity(section, input.value);
        });
      });

      section.querySelectorAll('.bc-product-waterflow__faq button').forEach(function(button) {
        button.addEventListener('click', function() {
          var item = button.closest('.bc-product-waterflow__faq-item');
          var panel = document.getElementById(button.getAttribute('aria-controls'));
          var willOpen = button.getAttribute('aria-expanded') !== 'true';
          if (!item || !panel) return;
          button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          item.classList.toggle('is-open', willOpen);
          panel.toggleAttribute('hidden', !willOpen);
        });
      });

      section.querySelectorAll('[data-bc-countdown]').forEach(initCountdown);

      var selected = section.querySelector('[data-bc-variant-button].is-selected') || section.querySelector('[data-bc-variant-button]');
      if (selected) updateVariant(section, selected);
    }

    function initAllSections() {
      document.querySelectorAll('[data-bc-product-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllSections);
    } else {
      initAllSections();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  function blueysEscapeText(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character];
    });
  }

  function blueysBuildVariantCards() {
    document.querySelectorAll('[data-blueys-variant-card-data]').forEach(function (script) {
      var data;
      var escapeSelector = window.CSS && CSS.escape
        ? CSS.escape
        : function (value) {
            return String(value).replace(/["\\]/g, '\\$&');
          };

      try {
        data = JSON.parse(script.textContent);
      } catch (error) {
        return;
      }

      if (!data || !Array.isArray(data.variants)) return;

      var selector = 'variant-picker[data-section-id="' + escapeSelector(data.sectionId) + '"]';
      var picker = document.querySelector(selector);

      if (!picker) return;

      blueysWatchVariantPicker(picker);

      data.variants.forEach(function (variant) {
        var input = picker.querySelector('input[data-variant-id="' + escapeSelector(String(variant.id)) + '"]');
        if (!input) return;

        var label = input.closest('.variant-option__button-label');
        if (!label) return;

        label.dataset.blueysOptionEnhanced = 'true';
        label.classList.add('blueys-option-card-label');

        if (label.querySelector(':scope > .blueys-option-card')) return;

        var card = document.createElement('span');
        card.className = 'blueys-option-card';
        card.setAttribute('aria-hidden', 'true');

        var media = document.createElement('span');
        media.className = 'blueys-option-card__media';

        if (variant.image) {
          var image = document.createElement('img');
          image.src = variant.image;
          image.alt = '';
          image.loading = 'lazy';
          media.appendChild(image);
        }

        var content = document.createElement('span');
        content.className = 'blueys-option-card__content';

        var topline = document.createElement('span');
        topline.className = 'blueys-option-card__topline';

        var title = document.createElement('span');
        title.className = 'blueys-option-card__title';
        title.innerHTML = blueysEscapeText(variant.title);
        topline.appendChild(title);

        if (variant.badge) {
          var badge = document.createElement('span');
          badge.className = 'blueys-option-card__badge';
          badge.innerHTML = blueysEscapeText(variant.badge);
          topline.appendChild(badge);
        }

        var detail = document.createElement('span');
        detail.className = 'blueys-option-card__detail';
        detail.innerHTML = blueysEscapeText(variant.detail);

        var bottom = document.createElement('span');
        bottom.className = 'blueys-option-card__bottom';

        var note = document.createElement('span');
        note.className = 'blueys-option-card__note';
        note.innerHTML = blueysEscapeText(variant.available ? variant.note : 'Currently unavailable');

        var price = document.createElement('span');
        price.className = 'blueys-option-card__price';
        price.innerHTML = blueysEscapeText(variant.price);

        if (variant.compareAtPrice) {
          var compare = document.createElement('span');
          compare.className = 'blueys-option-card__compare';
          compare.innerHTML = blueysEscapeText(variant.compareAtPrice);
          price.appendChild(compare);
        }

        bottom.appendChild(note);
        bottom.appendChild(price);

        content.appendChild(topline);
        content.appendChild(detail);
        content.appendChild(bottom);
        card.appendChild(media);
        card.appendChild(content);

        if (Array.isArray(variant.bullets) && variant.bullets.length) {
          var bullets = document.createElement('ul');
          bullets.className = 'blueys-option-card__bullets';

          variant.bullets.slice(0, 3).forEach(function (bulletText) {
            if (!bulletText) return;

            var bullet = document.createElement('li');
            bullet.innerHTML = blueysEscapeText(bulletText);
            bullets.appendChild(bullet);
          });

          if (bullets.children.length) {
            card.appendChild(bullets);
          }
        }

        label.appendChild(card);
      });
    });
  }

  function blueysRefreshVariantCardsSoon() {
    window.requestAnimationFrame(blueysBuildVariantCards);
    window.setTimeout(blueysBuildVariantCards, 80);
    window.setTimeout(blueysBuildVariantCards, 300);
    blueysPlaceSubscriptionWidgetSoon();
  }

  function blueysWatchVariantPicker(picker) {
    if (picker.dataset.blueysOptionObserver === 'true') return;

    picker.dataset.blueysOptionObserver = 'true';

    var observer = new MutationObserver(function () {
      window.clearTimeout(picker.blueysOptionRefreshTimer);
      picker.blueysOptionRefreshTimer = window.setTimeout(blueysBuildVariantCards, 0);
    });

    observer.observe(picker, {
      childList: true,
      subtree: true,
    });

    picker.addEventListener('change', blueysRefreshVariantCardsSoon);
    picker.addEventListener('click', blueysRefreshVariantCardsSoon);
  }

  function blueysGetSubscriptionBlock() {
    var container = document.querySelector('.shopify_subscriptions_app_container');

    if (!container) return null;

    return container.closest('.shopify-app-block') || container;
  }

  function blueysSubscriptionHasActivePlan(block) {
    if (!block) return false;

    return Boolean(block.querySelector('.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)'));
  }

  function blueysPlaceSubscriptionWidget() {
    var block = blueysGetSubscriptionBlock();
    var aside = document.querySelector('.blueys-product-aside');

    if (!block || !aside) return;

    var productDetails = aside.querySelector('.product-details') || aside;
    var buyButtons = productDetails.querySelector('.buy-buttons-block') || productDetails.querySelector('product-form-component');

    if (!buyButtons || !buyButtons.parentElement) return;

    var slot = productDetails.querySelector('.blueys-subscription-slot');

    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'blueys-subscription-slot';
      slot.setAttribute('data-blueys-subscription-slot', 'true');
    }

    if (slot.parentElement !== buyButtons.parentElement || slot.nextElementSibling !== buyButtons) {
      buyButtons.parentElement.insertBefore(slot, buyButtons);
    }

    if (block.parentElement !== slot) {
      slot.appendChild(block);
    }

    block.classList.add('blueys-subscription-card');

    var hasActivePlan = blueysSubscriptionHasActivePlan(block);
    slot.hidden = !hasActivePlan;
    block.hidden = !hasActivePlan;
  }

  function blueysPlaceSubscriptionWidgetSoon() {
    if (window.blueysSubscriptionPlacementTimer) {
      window.clearTimeout(window.blueysSubscriptionPlacementTimer);
    }

    window.requestAnimationFrame(blueysPlaceSubscriptionWidget);
    window.blueysSubscriptionPlacementTimer = window.setTimeout(blueysPlaceSubscriptionWidget, 120);
    window.setTimeout(blueysPlaceSubscriptionWidget, 420);
  }

  function blueysWatchSubscriptionPlacement() {
    if (document.documentElement.dataset.blueysSubscriptionPlacementObserver === 'true') return;

    document.documentElement.dataset.blueysSubscriptionPlacementObserver = 'true';

    var observer = new MutationObserver(function (mutations) {
      var shouldRefresh = mutations.some(function (mutation) {
        if (mutation.type === 'childList') return mutation.addedNodes.length || mutation.removedNodes.length;

        if (mutation.type === 'attributes') {
          return mutation.target.classList && (
            mutation.target.classList.contains('shopify_subscriptions_app_block') ||
            mutation.target.closest('.shopify_subscriptions_app_container')
          );
        }

        return false;
      });

      if (shouldRefresh) {
        blueysPlaceSubscriptionWidgetSoon();
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style', 'data-variant-id'],
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      blueysBuildVariantCards();
      blueysPlaceSubscriptionWidgetSoon();
      blueysWatchSubscriptionPlacement();
    });
  } else {
    blueysBuildVariantCards();
    blueysPlaceSubscriptionWidgetSoon();
    blueysWatchSubscriptionPlacement();
  }

  document.addEventListener('shopify:section:load', function () {
    blueysBuildVariantCards();
    blueysPlaceSubscriptionWidgetSoon();
    blueysWatchSubscriptionPlacement();
  });
  document.addEventListener('variant:change', blueysRefreshVariantCardsSoon);
  document.addEventListener('product:variant-change', blueysRefreshVariantCardsSoon);

  } catch(e) { console.error(e); }
})();
})();
